const smartLinkEndpoint = '/api/health/api/smartLink'

const getLinkMetaData = async (link: string, token: any) => {
    if (!link) throw Error('No link provided')
    if (!token) throw Error('No token provided')

    return await fetch(`${smartLinkEndpoint}/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ link })
    })
}

export { getLinkMetaData }